import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock"
export function lockBodyScroll(el: HTMLElement): void {
    disableBodyScroll(el);
}

export function releaseBodyScroll(el: HTMLElement): void {
    enableBodyScroll(el)
}